<script setup lang="ts">
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

const auth = useAuthStore()
const router = useRouter()

const email = ref('')
const password = ref('')

async function onSubmit() {
  if (await auth.login(email.value, password.value)) {
    await router.push('/dashboard')
  }
}
</script>

<template>
  <main class="auth-shell">
    <section class="auth-card">
      <header>
        <img class="brand-seal" src="/brand/oshela-icon.svg" alt="اوشلا" width="56" height="56">
        <h1>{{ $t('auth.signIn') }}</h1>
        <p>{{ $t('auth.hint') }}</p>
      </header>

      <form @submit.prevent="onSubmit">
        <label for="email">{{ $t('auth.email') }}</label>
        <input id="email" v-model="email" type="email" autocomplete="username" required>

        <label for="password">{{ $t('auth.password') }}</label>
        <input id="password" v-model="password" type="password" autocomplete="current-password" required>

        <button type="submit" :disabled="auth.pending">
          {{ auth.pending ? $t('auth.submitting') : $t('auth.submit') }}
        </button>
      </form>

      <p v-if="auth.error" class="auth-error" role="alert">{{ auth.error }}</p>
    </section>
  </main>
</template>

<style scoped>
.auth-error {
  margin: 16px 0 0;
  font-size: 0.85rem;
  color: var(--rose-deep);
  text-align: center;
}
</style>
